"use client";

import LocaleLink from "@/component/layout/LocaleLink";
import { useUnitsMap } from "@/hooks/useUnitsMap";
import { useCompare } from "@/lib/compare-store";
import type { Locale, Unit } from "@/types/units";
import { useLocale } from "next-intl";

/** Sticky bottom CTA bar — one action per compared unit. */
export default function CompareFooterCTA() {
  const locale = useLocale() as Locale;
  const ar = locale === "ar";
  const compare = useCompare();
  const { map } = useUnitsMap();
  const units = compare.codes.map((c) => map.get(c)).filter(Boolean) as Unit[];

  if (units.length === 0) return null;

  return (
    <div className="sticky bottom-0 z-30 border-t border-black/10 bg-white/95 px-6 py-5 backdrop-blur lg:px-10 dark:border-white/10 dark:bg-ash/95">
      <div className="mx-auto flex max-w-360 flex-wrap items-center justify-center gap-4 lg:justify-end">
        {units.map((u) =>
          u.status === "available" ? (
            <LocaleLink
              key={u.code}
              href="/contact"
              className="flex h-14 items-center justify-center bg-accent px-8 text-[11px] font-semibold uppercase tracking-widest text-white transition-colors hover:bg-ash dark:hover:bg-white dark:hover:text-ash"
            >
              {ar ? `احجز ${u.code}` : `Book ${u.code}`}
            </LocaleLink>
          ) : (
            <span
              key={u.code}
              className="flex h-14 cursor-not-allowed items-center justify-center bg-black/10 px-8 text-[11px] font-semibold uppercase tracking-widest text-ash/40 dark:bg-white/10 dark:text-white/40"
            >
              {ar ? `${u.code} غير متاحة` : `${u.code} unavailable`}
            </span>
          ),
        )}
      </div>
    </div>
  );
}
